export default __webpack_public_path__ + "static/media/lunch.519de8b2.svg";